import React, { useState, useEffect } from "react";
import i18n from "../i18n.js";
import { Link, useLocation } from "react-router-dom";
import Button from "@mui/material/Button";
import { useForm, Controller } from "react-hook-form";
import Box from "@mui/material/Box";
import LinearProgress from "@mui/material/LinearProgress";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import Skeleton from "@mui/material/Skeleton";
import Alert from "@mui/material/Alert";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import HowToRegIcon from "@mui/icons-material/HowToReg";
import PersonSearchIcon from "@mui/icons-material/PersonSearch";
import Container from "@mui/material/Container";
import axios from "axios";
import Athlete from "./components/WdsfAthlete";
import { parse, compareAsc } from "date-fns";

const WdsfSolo = (props) => {
    // eslint-disable-next-line react/prop-types
    const { itemOptions } = props;
    const { api, comp } = itemOptions;
    const { t } = i18n;

    const [loading, setLoading] = useState(false);
    const [person, setPerson] = useState([]);
    const [email, setEmail] = useState("");
    const [notActive, setNotActive] = useState(false);
    const [notFound, setNotFound] = useState(false);
    const [code, setCode] = useState("");
    let { state } = useLocation();
    useEffect(() => {
        setCode(state.code);
    }, []);
    const {
        handleSubmit,
        control,
        watch,
        formState: { errors, isValid },
    } = useForm({
        defaultValues: {
            min: "",
            email: "",
        },
    });
    const onSubmit = (data) => {

        if (isValid || Object.entries(errors).length === 0) {
            setLoading(true);

            setNotActive(false);
            setNotFound(false);
            setPerson([]);
            setEmail(data.email);
            // console.log(data);
            axios
                .get(`${api.getWdsfAthleteByMin}${data.min}`, data)
                .then(function (response) {
         
                    const fetchedPerson = response.data.person;
                    let activeAthlete = false;
                    if (fetchedPerson !== null) {
                        const compStart = parse(comp.dateStart, "yyyy-LL-dd", new Date());
                        fetchedPerson.licenses.forEach((l) => {
                            const expDate = parse(l.expiresOn, "yyyy-LL-dd", new Date());
                            if (l.type === "Athlete" && compareAsc(expDate, compStart) > 0) {
                                activeAthlete = true;
                            }
                        });
                        if (activeAthlete) {
                            setPerson(fetchedPerson);
                        } else {
                            setNotActive(true);
                        }
                    } else {
                        setNotFound(true);
                    }

                    setLoading(false);
                })
                .catch(function (error) {
                    setLoading(false);

                    console.log(error);
                });
        } else {
            console.log(errors);

        }
    };
    const onError = (errors, e) => {
        console.log(errors);
    };

    const againClick = () => {
        setPerson([]);
    };
    useEffect(() => {
        setEmail(watch["email"]);

    }, [watch["email"]]);
    // console.log(person);
    return (
        <React.Fragment>
            <hr />
            <h2 className="display-6 mt-2">{t("reg.wdsf.solo")}</h2>
            <p>{t("reg.info.wdsf.solo")}</p>
            {person.length === 0 && (
                <Container maxWidth="xs" className="mb-2">
                    <Box>
                        <form onSubmit={handleSubmit(onSubmit, onError)}>
                            <Stack direction="column" spacing={{ xs: 1, sm: 1, md: 4 }}>
                                <Controller
                                    name="email"
                                    control={control}
                                    rules={{
                                        pattern:
                                            /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/,
                                    }}
                                    render={({ field }) => (
                                        <TextField
                                            {...field}
                                            label={t("email")}
                                            type="email"
                                            required
                                            error={errors.email !== undefined}
                                            helperText={errors.email !== undefined ? t("reg.wdsf.helper.email") : ""}
                                        />
                                    )}
                                />
                                <Controller
                                    name="min"
                                    control={control}
                                    rules={{ pattern: /[1]{1}[0-9]{7}/ }}
                                    render={({ field }) => (
                                        <TextField
                                            {...field}
                                            label={t("wdsf_min")}
                                            type="text"
                                            required
                                            error={errors.min !== undefined}
                                            helperText={errors.min !== undefined ? t("reg.wdsf.helper.min") : ""}
                                        />
                                    )}
                                />

                                {!loading && (
                                    <Button type="submit" variant="outlined">
                                        {t("reg.wdsf.search")}
                                    </Button>
                                )}
                                {loading && <LinearProgress />}
                            </Stack>
                        </form>
                    </Box>
                </Container>
            )}
            {(loading || person?.id !== undefined) && (
                <Card variant="outlined">
                    <CardContent>
                        {loading && (
                            <Stack spacing={1}>
                                <Skeleton variant="rectangular" width={210} height={60} />
                                <Skeleton variant="rectangular" width={210} height={60} />
                                <Skeleton variant="rectangular" width={210} height={60} />
                            </Stack>
                        )}
                        {person?.id !== undefined && (
                            <Stack spacing={1}>
                                <Athlete person={person} t={t} />
                                <Button variant="contained" color="warning" onClick={againClick} startIcon={<PersonSearchIcon />}>
                                    {t("reg.wdsf.again")}
                                </Button>
                                <Link
                                    to="/categories"
                                    state={{
                                        person1: person,
                                        person2: null,
                                        couple: null,
                                        team: null,
                                        email: email,
                                        fromWdsf: true,
                                        fromForm: false,
                                        isSolo: true,
                                        isCouple: false,
                                        isTeam: false,
                                        code:code

                                    }}
                                >
                                    <Button variant="contained" startIcon={<HowToRegIcon />} fullWidth>
                                        {t("reg.wdsf.continue")}
                                    </Button>
                                </Link>
                            </Stack>
                        )}
                        {/* </div> */}
                    </CardContent>
                </Card>
            )}
            {notActive && <Alert severity="error">{t("reg.wdsf.not_active_athlete")}</Alert>}
            {notFound && <Alert severity="warning">{t("reg.wdsf.not_found_athlete")}</Alert>}
        </React.Fragment>
    );
};

export default WdsfSolo;
